// Inhalte der neuen Produktseiten (Entwurf ~/Projects/davidmedia-header-test/produkt.html + daten.js,
// Stand 04.10.2026), deutsch und englisch. Preise, Bilder der Galerie und Downloads stehen weiter in
// pages/ProductDetail.jsx (productsData) — hier steht nur, was die Seite erzählt.
//
// Die Fakten (Anzahl Vorlagen usw.) kommen aus den Titelbildern (ProduktBilder/serie/produkte.js).
// Ein Demo-Video kommt dazu, indem es als public/produkt/video/<id>.mp4 abgelegt und unten bei
// `video` eingetragen wird; ohne Eintrag zeigt „In Aktion“ den Platzhalter.

import { WERKZEUGE, GRATIS } from '../components/startseite/texte';
import { titelPfad } from '../components/produktseite/Kopf';

const INSTALLER_BILD = '/produkt/installer.webp';
const vorlagen = id => `/produkt/vorlagen/${id}.webp`;
const einstellungen = id => `/produkt/einstellungen/${id}.webp`;

// Kategorie für Brotkrumen und „Weitere Werkzeuge“
const KAT = {
  animation: { de: 'Animation', en: 'Animation' },
  text: { de: 'Text', en: 'Text' },
  layout: { de: 'Layout', en: 'Layout' },
  farbe: { de: 'Farbe', en: 'Color' },
  bausteine: { de: 'Bausteine', en: 'Building blocks' },
  paket: { de: 'All-in-One', en: 'All-in-One' },
  kostenlos: { de: 'Kostenlos', en: 'Free' },
};

const EIGENE = { de: ['Eigene', 'sichern und in jedem Projekt nutzen'], en: ['Your own', 'save them and use them in every project'] };
const eigene = (wortDe, wortEn) => ({ de: [EIGENE.de[0], wortDe, EIGENE.de[1]], en: [EIGENE.en[0], wortEn, EIGENE.en[1]] });

// art: werkzeug (Einzelkauf) · abo (nur im All-in-One) · gratis-panel (kostenlos, kommt über den
// Installer) · gratis (kostenloser Download) · bald (noch nicht erhältlich)
const SEITEN = {
  'instant-curve': {
    art: 'werkzeug', kat: 'animation', video: '/produkt/video/instant-curve.mp4',
    punkte: [
      { de: ['32', 'Vorlagen', 'Wertkurve und Geschwindigkeit'], en: ['32', 'presets', 'value and speed curves'] },
      { de: ['1 Klick', 'Easing', 'statt Graph-Editor: wählen, anwenden, fertig'], en: ['1 click', 'easing', 'instead of the Graph Editor: pick, apply, done'] },
      eigene('Kurven', 'curves'),
    ],
    versprechen: { de: ['Von Hand: Graph-Editor öffnen und Anfasser ziehen', 'Mit dem Werkzeug: 1 Klick'], en: ['By hand: open the Graph Editor and drag handles', 'With the tool: 1 click'] },
    schritte: {
      de: [['Vorlage wählen', 'Keyframes markieren und im Panel eine Kurve antippen. Die Vorschau zeigt sofort, wie sie wirkt.'],
           ['Feinjustieren', 'Wert- oder Geschwindigkeitskurve anpassen. Was gefällt, sicherst du als eigene Vorlage.'],
           ['Anwenden', 'Instant Curve schreibt das Easing direkt auf die Keyframes. Fertig, ohne Graph-Editor.']],
      en: [['Pick a preset', 'Select keyframes and tap a curve in the panel. The preview shows the result right away.'],
           ['Fine-tune', 'Adjust the value or speed curve. Save what you like as your own preset.'],
           ['Apply', 'Instant Curve writes the easing straight onto the keyframes. Done, no Graph Editor.']],
    },
  },
  'bounce-flow': {
    art: 'werkzeug', kat: 'animation', video: '/produkt/video/bounce-flow.mp4',
    punkte: [
      { de: ['15', 'Bounces', 'Federn und Overshoot fertig eingestellt'], en: ['15', 'bounces', 'spring and overshoot ready to go'] },
      { de: ['Ohne', 'Keyframes', 'der Nachschwinger läuft per Expression'], en: ['No', 'keyframes', 'the overshoot runs on an expression'] },
      eigene('Bounces', 'bounces'),
    ],
  },
  'shake-flow': {
    art: 'werkzeug', kat: 'animation', video: '/produkt/video/shake-flow.mp4',
    nutzen: { de: 'Kamerawackeln mit einem Klick, von der leichten Handkamera bis zum Einschlag.', en: 'Camera shake in one click, from a light handheld feel to a hard impact.' },
    punkte: [
      { de: ['24', 'Shakes', 'von sanftem Wackeln bis Erdbeben'], en: ['24', 'shakes', 'from a gentle wobble to an earthquake'] },
      { de: ['Kein', 'Code', 'die Expression schreibt das Werkzeug'], en: ['No', 'code', 'the tool writes the expression'] },
      eigene('Shakes', 'shakes'),
    ],
  },
  'glitch-flow': {
    art: 'werkzeug', kat: 'animation', video: '/produkt/video/glitch-flow.mp4',
    punkte: [
      { de: ['8', 'Glitch-Stacks', 'gestapelte Einstellungsebenen'], en: ['8', 'glitch stacks', 'stacked adjustment layers'] },
      { de: ['1 Regler', 'für alles', 'eine gemeinsame Steuerung für den Stack'], en: ['1 slider', 'for everything', 'one shared control for the whole stack'] },
      eigene('Stacks', 'stacks'),
    ],
  },
  'text-flow': {
    art: 'werkzeug', kat: 'text', video: '/produkt/video/text-flow.mp4',
    punkte: [
      { de: ['9', 'Text-Looks', 'fertig gestylt und animiert'], en: ['9', 'text looks', 'styled and animated'] },
      { de: ['Untertitel', 'aus SRT', 'gestylte Untertitel-Ebenen in einem Rutsch'], en: ['Subtitles', 'from SRT', 'styled subtitle layers in one go'] },
      eigene('Vorlagen', 'presets'),
    ],
  },
  'grid-flow': {
    art: 'werkzeug', kat: 'layout', video: '/produkt/video/grid-flow.mp4',
    punkte: [
      { de: ['1 Klick', 'Raster', 'Spalten, Zeilen und Abstände einstellen'], en: ['1 click', 'grid', 'set columns, rows and spacing'] },
      { de: ['Ebenen', 'anordnen', 'vorhandene Ebenen ins Raster sortieren'], en: ['Arrange', 'layers', 'sort existing layers into the grid'] },
      { de: ['Eigene', 'Vorlagen', 'Raster sichern und in jedem Projekt nutzen'], en: ['Your own', 'presets', 'save grids and use them in every project'] },
    ],
  },
  'carousel-flow': {
    art: 'werkzeug', kat: 'layout', video: '/produkt/video/carousel-flow.mp4',
    punkte: [
      { de: ['10', 'Layouts', 'Kreis, Ring und Bogen'], en: ['10', 'layouts', 'circle, ring and arc'] },
      { de: ['Geriggte', 'Drehung', 'ein Regler dreht das ganze Karussell'], en: ['Rigged', 'rotation', 'one slider spins the whole carousel'] },
      eigene('Layouts', 'layouts'),
    ],
  },
  'shape-flow': {
    art: 'werkzeug', kat: 'layout', video: '/produkt/video/shape-flow.mp4',
    punkte: [
      { de: ['10', 'Box-Vorlagen', 'mit Farbverlauf, geriggt'], en: ['10', 'box presets', 'with gradients, rigged'] },
      { de: ['Draw-On', 'Linien', 'animierte Linien und Rahmen'], en: ['Draw-on', 'lines', 'animated lines and frames'] },
      eigene('Formen', 'shapes'),
    ],
  },
  'background-flow': {
    art: 'werkzeug', kat: 'layout', video: '/produkt/video/background-flow.mp4',
    punkte: [
      { de: ['12', 'Hintergründe', 'weiche Mesh-Verläufe'], en: ['12', 'backgrounds', 'soft mesh gradients'] },
      { de: ['Sanfte', 'Bewegung', 'randlos bis in die Ecken'], en: ['Smooth', 'motion', 'seamless right into the corners'] },
      eigene('Paletten', 'palettes'),
    ],
  },
  'instant-ui-kit': {
    art: 'werkzeug', kat: 'layout', video: '/produkt/video/instant-ui-kit.mp4',
    punkte: [
      { de: ['123', 'UI-Elemente', 'Buttons, Karten, Toggles, Diagramme'], en: ['123', 'UI elements', 'buttons, cards, toggles, charts'] },
      { de: ['131', 'Handy-Screens', 'vom Sperrbildschirm bis zum Chat'], en: ['131', 'phone screens', 'from lock screen to chat'] },
      { de: ['Echte', 'Ebenen', 'Form- und Text-Ebenen, sofort beschriftbar'], en: ['Real', 'layers', 'shape and text layers, ready to edit'] },
    ],
    // Die Einstellungs-Aufnahme des Entwurfs trägt noch den alten Namen „Graph Flow“
    ansichten: [['ueberblick'], ['UI-Elemente', 'UI elements', vorlagen('instant-ui-kit')], ['installer']],
    versprechen: { de: ['Von Hand: Screen bauen, exportieren, importieren', 'Mit dem UI Kit: 1 Klick'], en: ['By hand: design, export, import every screen', 'With the UI Kit: 1 click'] },
    schritte: {
      de: [['Element wählen', 'UI-Element oder Handy-Screen aussuchen.'], ['Einsetzen', 'Es landet als echte Form- und Text-Ebenen in deiner Comp.'], ['Beschriften', 'Texte direkt in After Effects ändern.']],
      en: [['Pick an element', 'Choose a UI element or a phone screen.'], ['Insert', 'It lands in your comp as real shape and text layers.'], ['Edit the text', 'Change every label right inside After Effects.']],
    },
  },
  'instant-grade': {
    art: 'werkzeug', kat: 'farbe', video: '/produkt/video/instant-grade.mp4',
    nutzen: { de: 'Color-Grading direkt in After Effects: Looks anlegen, abrufen und kombinieren.', en: 'Color grading right inside After Effects: build, recall and stack looks.' },
    punkte: [
      { de: ['22', 'Looks', 'Cinematic, Warm, Cool, Vintage, S/W'], en: ['22', 'looks', 'cinematic, warm, cool, vintage, b/w'] },
      { de: ['Live-', 'Vorschau', 'auf deinem eigenen Frame'], en: ['Live', 'preview', 'on your own frame'] },
      { de: ['Eigene', 'Looks', 'bauen, sichern, als LUT nutzen'], en: ['Your own', 'looks', 'build, save, use as a LUT'] },
    ],
    // Die Farbräder-Aufnahme des Entwurfs trägt noch den alten Namen „LookFlow“
    ansichten: [['ueberblick'], ['Looks', 'Looks', vorlagen('instant-grade')], ['installer']],
    versprechen: { de: ['Von Hand: Kurven und Farbräder von null', 'Mit Instant Grade: 1 Klick'], en: ['By hand: curves and color wheels from scratch', 'With Instant Grade: 1 click'] },
    schritte: {
      de: [['Look wählen', 'Ebene markieren und einen der Looks antippen.'], ['Feinjustieren', 'Mit Farbrädern und Kurven anpassen, live auf deinem Frame.'], ['Anwenden', 'Look auf die Ebene legen oder als eigenen sichern, auch als LUT.']],
      en: [['Pick a look', 'Select a layer and tap one of the looks.'], ['Fine-tune', 'Adjust with color wheels and curves, live on your frame.'], ['Apply', 'Put the look on the layer or save it as your own, even as a LUT.']],
    },
  },
  'instant-comp': {
    art: 'werkzeug', kat: 'bausteine', video: '/produkt/video/instant-comp.mp4',
    punkte: [
      { de: ['Eigene', 'Comps', 'als Bausteine sichern'], en: ['Your own', 'comps', 'saved as building blocks'] },
      { de: ['1 Klick', 'einsetzen', 'am Zeitzeiger in jede Komposition'], en: ['1 click', 'to insert', 'at the playhead, into any comp'] },
      { de: ['Mit', 'Vorschau', 'jeder Baustein zeigt ein kurzes Video'], en: ['With', 'preview', 'every block shows a short video'] },
    ],
    ansichten: [['ueberblick'], ['Bausteine', 'Building blocks', vorlagen('instant-comp')], ['installer']],
    versprechen: { de: ['Von Hand: Comp suchen, kopieren, anpassen', 'Mit Instant Comp: 1 Klick'], en: ['By hand: find the comp, copy it, adapt it', 'With Instant Comp: 1 click'] },
    schritte: {
      de: [['Comp bauen', 'Deine Animation ganz normal in After Effects aufbauen.'], ['Als Baustein sichern', 'Ein Klick, After Effects rendert die Vorschau gleich mit.'], ['Einsetzen', 'Baustein antippen, er landet am Zeitzeiger.']],
      en: [['Build a comp', 'Build your animation in After Effects as usual.'], ['Save as a block', 'One click, After Effects renders the preview along with it.'], ['Insert', 'Tap the block and it lands at the playhead.']],
    },
  },

  // ---------- nur im All-in-One ----------
  'studio-flow': {
    art: 'abo', kat: 'paket', titel: '/products/titel/studio-flow.jpg',
    nutzen: { de: 'Alle Werkzeuge zusammen in einem einzigen Panel. Gibt es nur im All-in-One.', en: 'Every tool together in one single panel. Only available in the All-in-One.' },
    punkte: [
      { de: ['Alle', 'Werkzeuge', 'zusammen in einem einzigen Panel'], en: ['All', 'tools', 'together in one single panel'] },
      { de: ['Nur', 'im All-in-One', 'einzeln gibt es Studio Flow nicht'], en: ['Only', 'in All-in-One', 'Studio Flow isn’t sold separately'] },
      { de: ['Neue', 'Werkzeuge', 'kommen automatisch dazu'], en: ['New', 'tools', 'are added automatically'] },
    ],
    // Aufnahmen der Startseite (als WebP); ihre Titelleiste trägt noch den alten Namen, darum liegt „Studio Flow“ darüber
    ansichten: [['ueberblick'],
      ['Kurven', 'Curves', '/startseite/panel/instant-curve.webp', 'Studio Flow'],
      ['Shake', 'Shake', '/startseite/panel/shake-flow.webp', 'Studio Flow'],
      ['Text', 'Text', '/startseite/panel/text-flow.webp', 'Studio Flow'],
      ['Raster', 'Grid', '/startseite/panel/grid-flow.webp', 'Studio Flow'],
      ['installer']],
    versprechen: { de: ['Einzeln: ein Panel pro Werkzeug', 'Mit Studio Flow: ein Panel für alles'], en: ['Separately: one panel per tool', 'With Studio Flow: one panel for everything'] },
    schritte: {
      de: [['Bereich wählen', 'Links im Panel antippen, was du brauchst: Kurven, Bounce, Shake, Text, Raster und mehr.'], ['Vorlage antippen', 'Ebene oder Keyframes markieren, Vorlage wählen, Werte bei Bedarf anpassen.'], ['Anwenden', 'Studio Flow schreibt das Ergebnis direkt in deine Komposition. Alles in einem Panel.']],
      en: [['Pick an area', 'Tap what you need on the left: curves, bounce, shake, text, grid and more.'], ['Tap a preset', 'Select a layer or keyframes, pick a preset, adjust the values if you like.'], ['Apply', 'Studio Flow writes the result straight into your comp. All in one panel.']],
    },
  },
  'transition-flow': {
    art: 'abo', kat: 'paket', titel: '/products/transitions.png',
    punkte: [
      { de: ['Übergänge', 'am Schnitt', 'Wischer, Blenden, Verzerrung'], en: ['Transitions', 'at the cut', 'wipes, fades, distortion'] },
      { de: ['Länge und', 'Richtung', 'stellst du im Panel ein'], en: ['Length and', 'direction', 'set right in the panel'] },
      { de: ['Nur', 'im All-in-One', 'braucht die Vorlagen der anderen Werkzeuge'], en: ['Only', 'in All-in-One', 'uses the presets of the other tools'] },
    ],
    ansichten: [['ueberblick']],
    schritte: {
      de: [['Ebenen wählen', 'Die zwei Ebenen markieren, zwischen denen der Übergang sitzen soll.'], ['Übergang antippen', 'Wischer, Blende oder Verzerrung wählen, Länge und Richtung einstellen.'], ['Anwenden', 'Die Keyframes landen genau dort, wo der Schnitt sitzt.']],
      en: [['Pick the layers', 'Select the two layers the transition should sit between.'], ['Tap a transition', 'Choose a wipe, fade or distortion, set length and direction.'], ['Apply', 'The keyframes land exactly where the cut is.']],
    },
  },

  // ---------- kostenlos ----------
  'flow-panel': {
    art: 'gratis-panel', kat: 'kostenlos',
    nutzen: { de: 'Deine installierten Werkzeuge in einem Fenster, ein Klick zum Öffnen. Kostenlos.', en: 'Your installed tools in one window, one click to open. Free.' },
    punkte: [
      { de: ['Alle', 'Werkzeuge', 'deine installierten Tools in einem Fenster'], en: ['All', 'tools', 'your installed tools in one window'] },
      { de: ['1 Klick', 'öffnen', 'statt Fenster › Erweiterungen durchsuchen'], en: ['1 click', 'to open', 'instead of digging through Window › Extensions'] },
      { de: ['100 %', 'kostenlos', 'für alle David-Media-Werkzeuge'], en: ['100%', 'free', 'for every David Media tool'] },
    ],
    // Die alte Panel-Aufnahme zeigt noch Graph Flow, Look Flow und Transition Flow
    ansichten: [['ueberblick'], ['installer']],
    versprechen: { de: ['Ohne: Fenster › Erweiterungen durchsuchen', 'Mit dem Flow Panel: 1 Klick'], en: ['Without: dig through Window › Extensions', 'With the Flow Panel: 1 click'] },
    schritte: {
      de: [['Installer laden', 'Der kostenlose Installer richtet das Flow Panel zusammen mit deinen Werkzeugen ein.'], ['Panel öffnen', 'In After Effects unter Fenster › Erweiterungen › Flow Panel.'], ['Werkzeug starten', 'Ein Klick öffnet jedes installierte Werkzeug in seinem eigenen Panel.']],
      en: [['Get the installer', 'The free installer sets up the Flow Panel together with your tools.'], ['Open the panel', 'In After Effects under Window › Extensions › Flow Panel.'], ['Launch a tool', 'One click opens any installed tool in its own panel.']],
    },
  },
  'text-animations': {
    art: 'gratis', kat: 'kostenlos', video: '/products/text-animations-preview.mp4',
    punkte: [
      { de: ['5+', 'Text-Animationen', 'als .ffx-Presets für After Effects'], en: ['5+', 'text animations', 'as .ffx presets for After Effects'] },
      { de: ['Drag &', 'Drop', 'auf jede Text-Ebene ziehen, fertig'], en: ['Drag &', 'drop', 'onto any text layer, done'] },
      { de: ['Inklusive', 'Projekt', '.aep-Datei mit allen Animationen'], en: ['Project', 'included', '.aep file with every animation'] },
    ],
    schritte: 'presets',
  },
  'text-animations-2': {
    art: 'gratis', kat: 'kostenlos', video: '/products/text-animations-2-preview.mp4',
    punkte: [
      { de: ['5+', 'Text-Animationen', 'als .ffx-Presets für After Effects'], en: ['5+', 'text animations', 'as .ffx presets for After Effects'] },
      { de: ['Kein', 'Plugin nötig', 'läuft in jedem After Effects'], en: ['No', 'plugin needed', 'runs in any After Effects'] },
      { de: ['Inklusive', 'Projekt', '.aep-Datei mit allen Animationen'], en: ['Project', 'included', '.aep file with every animation'] },
    ],
    schritte: 'presets',
  },
  'animated-gradients': {
    art: 'gratis', kat: 'kostenlos', video: '/products/animated-gradients-preview.mp4',
    punkte: [
      { de: ['10+', 'Verläufe', 'animiert, als After-Effects-Projekt'], en: ['10+', 'gradients', 'animated, as an After Effects project'] },
      { de: ['Für', 'Hintergründe', 'Übergänge und Overlays'], en: ['For', 'backgrounds', 'transitions and overlays'] },
      { de: ['Frei', 'anpassbar', 'Farben und Tempo selbst einstellen'], en: ['Fully', 'adjustable', 'set colors and speed yourself'] },
    ],
    versprechen: { de: ['Von Hand: Verlauf für Verlauf bauen', 'Mit dem Projekt: fertig zum Anpassen'], en: ['By hand: build every gradient yourself', 'With the project: ready to adjust'] },
    schritte: {
      de: [['Kostenlos laden', 'Paket herunterladen und entpacken.'], ['Projekt öffnen', 'Die .aep-Datei in After Effects öffnen oder importieren.'], ['Anpassen', 'Farben und Tempo einstellen, dann als Hintergrund, Übergang oder Overlay nutzen.']],
      en: [['Download for free', 'Download the package and unzip it.'], ['Open the project', 'Open or import the .aep file in After Effects.'], ['Adjust', 'Set colors and speed, then use it as a background, transition or overlay.']],
    },
  },
  'effect-flow': { art: 'bald', kat: 'paket' },
};

const STANDARD_SCHRITTE = name => ({
  de: [['Vorlage wählen', 'Ebene markieren und im Panel eine Vorlage antippen. Die Vorschau zeigt sofort, wie es wirkt.'],
       ['Feinjustieren', 'In den Einstellungen jeden Wert anpassen. Was gefällt, sicherst du als eigene Vorlage.'],
       ['Anwenden', `${name} schreibt das Ergebnis direkt auf die Ebene. Fertig, ohne eine Zeile Code.`]],
  en: [['Pick a preset', 'Select a layer and tap a preset in the panel. The preview shows the result right away.'],
       ['Fine-tune', 'Adjust every value in the settings. Save what you like as your own preset.'],
       ['Apply', `${name} writes the result straight onto the layer. Done, without a line of code.`]],
});
const PRESET_SCHRITTE = {
  de: [['Kostenlos laden', 'Paket herunterladen und entpacken.'], ['Preset ziehen', 'Die .ffx-Datei per Drag & Drop auf eine Text-Ebene ziehen.'], ['Anpassen', 'Text, Schrift und Timing ändern, oder im mitgelieferten Projekt stöbern.']],
  en: [['Download for free', 'Download the package and unzip it.'], ['Drag the preset', 'Drag & drop the .ffx file onto a text layer.'], ['Adjust', 'Change text, font and timing, or browse the included project.']],
};
const VERSPRECHEN = {
  werkzeug: { de: ['Von Hand: Expression schreiben und Werte suchen', 'Mit dem Werkzeug: 1 Klick'], en: ['By hand: write expressions and hunt for values', 'With the tool: 1 click'] },
  abo: { de: ['Einzeln: ein Panel pro Werkzeug', 'Im All-in-One: ein Panel für alles'], en: ['Separately: one panel per tool', 'In All-in-One: one panel for everything'] },
  gratis: { de: ['Von Hand: Keyframe für Keyframe animieren', 'Mit dem Preset: Drag & Drop'], en: ['By hand: animate keyframe by keyframe', 'With the preset: drag & drop'] },
};

// Fertige Seite für ein Produkt: alles, was die Komponente braucht, in der richtigen Sprache.
// `produkt` ist der Eintrag aus productsData (Name, Preis, Bilder).
export function produktSeite(id, produkt, en) {
  const sp = en ? 'en' : 'de';
  const s = SEITEN[id] || { art: produkt.priceValue === 0 ? 'gratis' : 'werkzeug', kat: 'animation' };
  const art = produkt.comingSoon ? 'bald' : s.art;
  const name = produkt.name;
  const bild0 = typeof produkt.images?.[0] === 'string' ? produkt.images[0] : null;
  const titel = titelPfad(s.titel || bild0, en);
  const wz = WERKZEUGE.find(w => w[0] === id), gr = GRATIS.find(g => g[0] === id);
  const nutzen = (s.nutzen && s.nutzen[sp]) || (wz && wz[en ? 5 : 4]) || (gr && gr[en ? 3 : 2]) || null;

  // Ansichten der 3D-Karte oben: Überblick · Vorlagen · Einstellungen · Im Installer
  let roh = s.ansichten;
  if (!roh) {
    if (art === 'werkzeug' && wz) {
      roh = [['ueberblick'], ['Vorlagen', 'Presets', vorlagen(id)]];
      if (['instant-curve', 'bounce-flow', 'shake-flow', 'glitch-flow', 'text-flow', 'grid-flow', 'carousel-flow', 'shape-flow', 'background-flow'].includes(id)) roh.push(['Einstellungen', 'Settings', einstellungen(id)]);
      roh.push(['installer']);
    } else {
      roh = [['ueberblick']];
      // Gratis-Pakete: die Vorschau läuft als zweite Ansicht direkt in der Karte
      if (s.video) roh.push(['Vorschau', 'Preview', s.video, null, 'video']);
      else (produkt.images || []).slice(1, 3).forEach((b, i) => { if (typeof b === 'string') roh.push([`Bild ${i + 2}`, `Image ${i + 2}`, b]); });
    }
  }
  const ansichten = roh.map(a => {
    if (a[0] === 'ueberblick') return { name: en ? 'Overview' : 'Überblick', src: titel };
    // auf dem Handy reicht „Installer“, sonst passen die Reiter nicht in die Box
    if (a[0] === 'installer') return { name: en ? 'In the installer' : 'Im Installer', kurz: 'Installer', src: INSTALLER_BILD };
    return { name: en ? a[1] : a[0], src: a[2], titelleiste: a[3] || null, video: a[4] === 'video' };
  }).filter(a => a.src);

  const schritte = s.schritte === 'presets' ? PRESET_SCHRITTE[sp]
    : s.schritte ? s.schritte[sp]
    : STANDARD_SCHRITTE(name)[sp];
  // Bilder des Ablauf-Fensters: Vorlagen, Einstellungen, Ergebnis (Video, sobald es eins gibt)
  const bilderOhne = ansichten.filter(a => !a.video && a.src !== INSTALLER_BILD);
  const ablauf = [bilderOhne[1] || bilderOhne[0], bilderOhne[2] || bilderOhne[1] || bilderOhne[0], bilderOhne[0]].map(a => a && { src: a.src, titelleiste: a.titelleiste });

  const versprechen = (s.versprechen || VERSPRECHEN[art === 'gratis-panel' ? 'werkzeug' : art] || VERSPRECHEN.werkzeug)[sp];
  const punkte = (s.punkte || []).map(p => p[sp]);

  return {
    id, name, art, titel, nutzen, ansichten, schritte, ablauf, versprechen, punkte,
    video: s.video || null,
    kat: s.kat, katName: KAT[s.kat] ? KAT[s.kat][sp] : '',
  };
}

// Für „Weitere Werkzeuge“: alles, was im Shop steht, mit Titelbild
export const SICHTBAR = [
  ...WERKZEUGE.map(w => ({ id: w[0], kat: w[2] })),
  { id: 'flow-panel', kat: 'kostenlos' },
  ...GRATIS.map(g => ({ id: g[0], kat: 'kostenlos' })),
];
